module.exports = __webpack_public_path__ + "img/financial-reporting.767ae01a.jpg";